export default {
  setSelections(state, val) {
    state.selections = val.selections
  },

  setNextWorkFlowStep(state, val) {
    state.nextStep = val.nextStep
  },

  setClaimID(state, val) {
    state.claimEventID = val.ID
  },

}



// WEBPACK FOOTER //
// ./src/Osm/Claim/store/mutations.js